<template>
  <split-pane
    v-if="showCodeEditors"
    :min-percent="2" 
    :default-percent="50" 
    split="horizontal">
    <template slot="paneL">
      <split-pane :min-percent="2" :default-percent="20" split="vertical">
        <template slot="paneL">
          <CodeEditor
            :value="tmpValue.static_data"
            language="yaml"
            @input="(value) => onCodeChange('static_data', value)"
          />
        </template>
        <template slot="paneR">
          <EditableSectionRender
            :value="tmpValue"
            @input="(value) => onValueChange(value)"
            :display-preview="displayPreview"
            :display-editable-box="displayEditableBox"
          />
        </template>
      </split-pane>
    </template>
    <template slot="paneR">
      <split-pane :min-percent="2" :default-percent="50" split="vertical">
        <div slot="paneL">
          <CodeEditor
            :value="tmpValue.template"
            language="html"
            @input="(value) => onCodeChange('template', value)"
          />
        </div>
        <div slot="paneR">
          <CodeEditor
            :value="tmpValue.style"
            language="css"
            @input="(value) => onCodeChange('style', value)"
          />
        </div>
      </split-pane>
    </template>
  </split-pane>
  <EditableSectionRender
    v-else
    :value="tmpValue"
    @input="(value) => onValueChange(value)"
    :display-preview="displayPreview"
    :display-editable-box="displayEditableBox"
  />
</template>


<script>
import { mapState } from "vuex";
import splitPane from "vue-splitpane";
import CodeEditor from "./CodeEditor";
import EditableSectionRender from './EditableSectionRender'
import TinyMCE from './TinyMCE.vue'

export default {
  name: "PageDevTool",
  components: {
    "split-pane": splitPane,
    CodeEditor,
    EditableSectionRender,
    TinyMCE,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    showCodeEditors: {
      type: Boolean,
      default: false,
    },
    displayEditableBox: {
      type: Boolean,
      default: true,
    },
    displayPreview: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      i18nMessage: (state) => state.i18nMessage,
      errors: (state) => state.errors,
      defaultGlobalStyles: state => state.defaultGlobalStyles,
    }),
    tmpValue () {
      return this.value
    },
  },
  mounted() {},
  methods: {
    onValueChange(newValue) {
      this.$emit('input', newValue)
    },
    onCodeChange(key, value) {
      const newValue = {
        ...this.tmpValue,
      }
      newValue[key] = value
      this.$emit('input', newValue)
    },
  },
};
</script>

<style scoped>
>>> .splitter-pane {
  overflow-y: auto;
}
</style>